import React from 'react';
import ReactDOM from 'react-dom';

import ViewportMapBlock from '../components/ViewportMapBlock';

const composed = () => {
  return <ViewportMapBlock />;
};

const container = document.getElementById('viewport-map-container');

if (container) {
  ReactDOM.render(composed(), container);
}
